import { GridModel } from "common/models/utility-models/list-utility.model";
import { ApplicantsReportsModel } from "./applicant-report-data-model";

export class ApplicantReportsGridModel extends ApplicantsReportsModel { }

export class ApplicantReportsListingModel extends GridModel<ApplicantsReportsModel> {
  filterData: any;
}